import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false as boolean;

const slice = createSlice({
  name: 'disableFetchDeliveryFeeApi',
  initialState,
  reducers: {
    setDisableFetchDeliveryFeeApi(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisableFetchDeliveryFeeApi } = slice.actions;

export default slice.reducer;
